<script>
export default {
  name: "UiCompletionList",
  props: {
    is_completed: {
      type: Boolean,
      default: false,
    },
  }
}
</script>

<template>
  <ul data-comp="UiCompletionList" class="list-inline p-0 m-0">
    <slot></slot>
  </ul>
</template>
